<div class="container-info">
    <div class="garbage-grid">
        <div class="garbage-left">
            <div class="d-flex fd-row station-info">
                <sit-icon 
                    [icon]="Icon.identification_card" 
                    [sizeClass]="'icon-size-24'"
                    matTooltipPosition="above"
                    matTooltipClass="tooltip-custom"
                    matTooltip="ID Contenedor"
                ></sit-icon>
                <h5 class="text-white">{{properties.licensePlate || properties.binId}}</h5>
            </div>
            <div class="d-flex fd-row station-info">
                <sit-icon 
                    [icon]="Icon.package_icon" 
                    [sizeClass]="'icon-size-24'"
                    matTooltipPosition="above"
                    matTooltipClass="tooltip-custom"
                    matTooltip="Categoría"
                ></sit-icon>
                <h5 class="text-white">{{properties.typeWaste }}</h5>
            </div>
            <div class="d-flex fd-row station-info">
                <sit-icon 
                    [icon]="Icon.spray_icon" 
                    [sizeClass]="'icon-size-24'"
                    matTooltipPosition="above"
                    matTooltipClass="tooltip-custom"
                    matTooltip="Fecha"
                ></sit-icon>
                <h5 class="text-white">
                    {{ getBinClearedTimeAsLocalDate() | date:'dd/MM/yyyy - HH:mm:ss' }}
                </h5>
            </div>
        </div>
        <div class="garbage-right">
            <div class="d-flex fd-row station-info">
                <sit-icon 
                    [icon]="Icon.check_circle_green" 
                    [sizeClass]="'icon-size-24'"
                    matTooltipPosition="above"
                    matTooltipClass="tooltip-custom"
                    matTooltip="Estado"
                ></sit-icon>
                <h5 class="text-white">Conectado</h5>
            </div>
            <div class="d-flex fd-row station-info">
                <sit-icon 
                    [icon]="Icon.ruler_icon" 
                    [sizeClass]="'icon-size-24'"
                    matTooltipPosition="above"
                    matTooltipClass="tooltip-custom"
                    matTooltip="Capacidad"
                ></sit-icon>
                <h5 class="text-white">Capacidad</h5>
            </div>
            <div class="garbage-visual">
                <div class="garbage-container">
                    <div class="garbage-fill" 
                         [style.height.%]="getPercentage()" 
                         [style.background-color]="getFillColor(getPercentage())"></div>
                </div>
                <h3 class="percentage" [style.color]="getFillColor(getPercentage())">{{(getPercentage() | number:'1.0-0')}}%</h3>
            </div>
        </div>
    </div>
</div>
